import { Box, useTheme } from '@mui/material';
import { HighlightOff as XCircle, CheckCircleOutline as CheckCircle } from '@mui/icons-material';

type StatusChecklistItems = { label: string; status: boolean };

type StatusChecklistProps = {
  title: string;
  items: StatusChecklistItems[];
};

export const StatusChecklist = ({ title, items }: StatusChecklistProps) => {
  const theme = useTheme();

  const renderCheckStatusIcon = (status: boolean) => {
    if (status) {
      return <CheckCircle sx={{ color: theme.palette.success.main }} />;
    }

    return <XCircle sx={{ color: theme.palette.error.main }} />;
  };

  return (
    <Box m={3} padding={3}>
      <h3>{title}</h3>
      {items.map((item) => (
        <Box key={item.label} display={'flex'} gap={4} fontSize={15}>
          <Box>{renderCheckStatusIcon(item.status)}</Box>
          {item.label}
        </Box>
      ))}
    </Box>
  );
};
